module.exports = __webpack_public_path__ + "img/tongzhi.a9586734.png";